import { isBoolean, startsWith, trim, words } from 'lodash';
import { emailRegExp, telE164RegExp } from 'utils/regexp';
import { FieldBBErrorType } from 'client/components/common/BuildingBlocks/Fields/constants';
import { Validations } from './types';

function getMaxSizeBytes(maxSizeMb: string | undefined): number {
	const number = parseFloat(maxSizeMb ?? '');
	return Number.isNaN(number) ? Infinity : number * 1024 * 1024;
}
function matchFileType(file: File, rule: string): boolean {
	const allowedExtensions = rule
		.split(',')
		.map(ext => ext.trim().toLowerCase())
		.filter(Boolean);
	const fileName = file.name.toLowerCase();

	return allowedExtensions.some(ext => fileName.endsWith(ext));
}
const minWords = (v: string, min: number) => words(v).length >= min;
const minChars = (v: string, min: number) => v.length >= min;
const noValue = (v: string | undefined) => v === '' || v === undefined;
export const isPhoneNumber = (v: string) =>
	startsWith(v, '+972')
		? /* israel phone number +9720123456789 */ /^(\+972)\d{10}$/.test(v)
		: startsWith(v, '+')
			? /* international format */ telE164RegExp.test(v)
			: /* not international format */ /^\d{9,14}$/.test(v);

// true === valid
export const validations: Validations = {
	[FieldBBErrorType.required]: v => {
		if (!v) return false;
		if (isBoolean(v)) return v;
		if (v instanceof File) return true;

		return trim(v) !== '';
	},
	[FieldBBErrorType.email]: v => noValue(v) || emailRegExp.test(v),
	[FieldBBErrorType.tel]: v => noValue(v) || isPhoneNumber(v),
	[FieldBBErrorType.fullName]: v => noValue(v) || (minWords(v, 2) && words(v).every(w => minChars(w, 2))),
	[FieldBBErrorType.fileSize]: (file, rules) =>
		!file || !rules.fileUploadMaxSizeMb || file.size <= getMaxSizeBytes(rules.fileUploadMaxSizeMb),
	[FieldBBErrorType.invalidFileType]: (file, rules) =>
		!file || !rules.fileUploadAllowedTypes || matchFileType(file, rules.fileUploadAllowedTypes),
	[FieldBBErrorType.genericError]: () => true,
};
